"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextMap = void 0;

var ContextMap =
/** @class */
function () {
  function ContextMap() {
    var _this = this;

    this._context = new Map();

    this.get = function (key) {
      return Promise.resolve(_this._context.get(key));
    };

    this.set = function (key, item) {
      if (!key) {
        throw new Error("A key is required to set the context");
      }

      if (!item) {
        throw new Error("An item is required to set the context");
      }

      _this._context.set(key, item);

      return _this;
    };
  }

  return ContextMap;
}();

exports.ContextMap = ContextMap;